import React from 'react'

import { Auth } from '../../modules/session'
import ListNotifications from '../messenger/ListNotifications'

const AuthTemplate = ({ children }) => {
  return (
    <Auth>
      {children}

      <ListNotifications />
    </Auth>
  )
}

export default AuthTemplate
